export default "__VITE_ASSET__L3eU_LVf__"